export default "__VITE_ASSET__DvqPHcPn__"